module.exports = __webpack_public_path__ + "static/media/ARIALBD1.858f5a50.TTF";